import { useState } from "react";
import Unauthorized from "../../Components/custom/Unauthrized";
import DataTable from "react-data-table-component";
import CustomLoader from "../../Components/custom/CustomLoader";
import PaginationControl from "../../Components/custom/PaginationControl";
import SearchBar from "../../Components/custom/SearchBar";
import moment from "moment";
import Filter from "../../Components/custom/Filter";
import { useFetch, useMutate } from "../../hooks/queries";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ListTeachers = (props) => {
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const [startDate] = useState(moment().subtract(7, "d").format("YYYY-MM-DD"));
  const [endDate] = useState(moment().format("YYYY-MM-DD"));

  const [selectedSchool, setSelectedSchool] = useState({
    label: "All Schools",
    value: 0,
  });

  const [selectedOperator, setSelectedOperator] = useState({
    label: "N/A",
    value: 0,
  });

  const handleFilterApply = ({ operator, school }) => {
    setSelectedOperator(
      operator || {
        label: "N/A",
        value: 0,
      },
    );
    setSelectedSchool(
      school || {
        label: "All Schools",
        value: 0,
      },
    );
    setPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setPage(1);
  };

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const handleSort = (column, sortDirection) => {
    const columnFieldMap = {
      canvasId: "CanvasId",
      name: "Name",
      email: "Email",
      canvasSchool: "CanvasSchool",
      schoolName: "SchoolName",
      lastLogin: "LastLogin",
    };
    setSortBy(columnFieldMap[column.id]);
    setSortOrder(sortDirection);
    setPage(1);
  };

  const columns = [
    {
      id: "canvasId",
      name: "Canvas Id",
      selector: (row) => row.canvasId,
      width: "150px",
      sortable: true,
      // cell: (row) => {
      //   const schoolsMismatch = row.canvasSchool !== row.schoolName;
      //   return (
      //     <div className='d-flex align-items-center gap-2'>
      //       <span>{row.canvasId}</span>
      //       {schoolsMismatch && (
      //         <OverlayTrigger
      //           placement='right'
      //           overlay={
      //             <Tooltip id={`tooltip-mismatch-${row.canvasId}`}>
      //               <div className='text-start'>
      //                 <strong>School Mismatch</strong>
      //                 <br />
      //                 <small>
      //                   Canvas: {row.canvasSchool || 'N/A'}
      //                   <br />
      //                   CSLP: {row.schoolName || 'N/A'}
      //                 </small>
      //               </div>
      //             </Tooltip>
      //           }
      //         >
      //           <span style={{ color: '#ffc107', cursor: 'pointer' }}>
      //             <BsFillExclamationTriangleFill size={16} />
      //           </span>
      //         </OverlayTrigger>
      //       )}
      //     </div>
      //   );
      // },
    },
    {
      id: "name",
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      id: "email",
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      id: "canvasSchool",
      name: "Canvas School",
      selector: (row) => row.canvasSchool,
      sortable: true,
    },
    {
      id: "schoolName",
      name: "CSLP School",
      selector: (row) => row.schoolName,
      sortable: true,
    },
    {
      id: "lastLogin",
      name: "Last Login Date",
      selector: (row) =>
        row.lastLogin == null
          ? "N/A"
          : moment(row.lastLogin).format("YYYY-MM-DD"),
      sortable: true,
    },
  ];

  const buildTeachersRequestBody = () => {
    const ot = localStorage.getItem("OTsReD");
    const st = localStorage.getItem("STsReD");

    const safeParseInt = (value) => {
      const parsed = parseInt(value);
      return isNaN(parsed) ? 0 : parsed;
    };

    const parsedOt = safeParseInt(ot);
    const parsedSt = safeParseInt(st);
    const selectedOp = selectedOperator?.value;
    const selectedSch = selectedSchool?.value;

    const data = {
      OperatorId: 0,
      SchoolId: 0,
      // StartDate: startDate,
      // EndDate: endDate,
      PageNumber: page,
      PageSize: perPage,
      SearchText: searchText,
      SortBy: sortBy,
      SortOrder: sortOrder,
    };

    if (parsedOt !== 0 && parsedSt === 0) {
      data.OperatorId = parsedOt;
      data.SchoolId = safeParseInt(selectedSch);
    } else if (parsedOt !== 0 && parsedSt !== 0) {
      data.OperatorId = parsedOt;
      data.SchoolId = parsedSt;
    } else {
      data.OperatorId = safeParseInt(selectedOp);
      data.SchoolId = safeParseInt(selectedSch);
    }

    return data;
  };

  const {
    data: teachersResponse,
    isPending,
    isLoading,
    isFetching,
  } = useFetch({
    queryKey: [
      "teachers",
      page,
      perPage,
      // startDate,
      // endDate,
      selectedSchool.value,
      selectedOperator.value,
      searchText,
      sortBy,
      sortOrder,
      localStorage.getItem("OTsReD"),
      localStorage.getItem("STsReD"),
    ],
    url: `${process.env.REACT_APP_API_URL}CanvasUsers/GetTeachers`,
    method: "PATCH",
    data: buildTeachersRequestBody(),
    enabled: props.userPermissions.viewTeachers !== false,
  });

  const teachers = teachersResponse?.data || [];
  const totalRows = teachersResponse?.totalCount || 0;

  const schoolsMismatchCount = teachers.filter(
    (teacher) => teacher.canvasSchool !== teacher.schoolName,
  ).length;

  const isTeachersLoading = isPending || isLoading || isFetching;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  const buildExportPayload = (filterData) => {
    const school = filterData?.school || selectedSchool;
    const operator = filterData?.operator || selectedOperator;

    return {
      // startDate: startDate,
      // endDate: endDate,
      schoolId: school.value == null ? 0 : school.value,
      operatorId: operator.value == null ? 0 : operator.value,
    };
  };

  const downloadTeachersFile = (data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, "Teachers.xlsx");
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "Teachers.xlsx");
      document.body.appendChild(link);
      link.download = "Teachers.xlsx";
      link.click();
      document.body.removeChild(link);
    }
  };

  const exportTeachersMutation = useMutate({
    mutationKey: ["exportTeachers"],
    url: `${process.env.REACT_APP_API_URL}CanvasUsers/ExportTeachers`,
    method: "PATCH",
    axiosConfig: {
      responseType: "arraybuffer",
    },
    onSuccess: (data) => {
      downloadTeachersFile(data);
    },
  });

  const exportingTeachers =
    exportTeachersMutation.isPending || exportTeachersMutation.isLoading;

  return (
    <>
      {props.userPermissions.viewTeachers == false ? (
        <Unauthorized />
      ) : (
        <div className="content">
          <Filter
            isLoading={isTeachersLoading}
            onApply={handleFilterApply}
            showExport={true}
            exportLabel="Export CSV"
            exporting={exportingTeachers}
            onExport={(filterData) =>
              exportTeachersMutation.mutate(buildExportPayload(filterData))
            }
          />

          <div className="left-side">
            <div className="container-fluid mt-30">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title d-flex align-items-center gap-2">
                    Teachers
                    {/* {schoolsMismatchCount > 0 && (
                      <OverlayTrigger
                        placement='right'
                        overlay={
                          <Tooltip id='tooltip-mismatch-header'>
                            <div className='text-start'>
                              <strong>
                                {schoolsMismatchCount} School Mismatch
                                {schoolsMismatchCount !== 1 ? 'es' : ''}
                              </strong>
                              <br />
                              <small>
                                Teachers with different Canvas and CSLP school
                                names
                              </small>
                            </div>
                          </Tooltip>
                        }
                      >
                        <span
                          className='badge'
                          style={{
                            backgroundColor: '#ffc107',
                            color: '#000',
                            fontSize: '0.75rem',
                            padding: '0.35em 0.65em',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                          }}
                        >
                          <BsFillExclamationTriangleFill size={12} />
                          {schoolsMismatchCount} Issue
                          {schoolsMismatchCount !== 1 ? 's' : ''}
                        </span>
                      </OverlayTrigger>
                    )} */}
                  </h3>
                  {/* <div style={{ width: "300px" }}>
                    <SearchBar
                      value={searchText}
                      onSearch={handleSearch}
                      onClear={handleClearSearch}
                      placeholder="Search teachers..."
                      debounceMs={500}
                      disabled={isTeachersLoading}
                    />
                  </div> */}
                </div>
                <div className="card-body p-0">
                  <DataTable
                    data={teachers}
                    columns={columns}
                    progressPending={isTeachersLoading}
                    progressComponent={<CustomLoader />}
                    fixedHeader
                    fixedHeaderScrollHeight={"65vh"}
                    defaultSortFieldId={1}
                    onSort={handleSort}
                    sortServer
                  />
                  <PaginationControl
                    totalCount={totalRows}
                    currentPage={page}
                    pageSize={perPage}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePerRowsChange}
                    pageSizeOptions={[10, 20, 50, 100, 200]}
                    disabled={isTeachersLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListTeachers;
